import React from 'react';
import properties from '../../../constants/Properties';
import mouseUtils from '../../../components/utils/MouseUtils';
import audioEditorUtils from '../utils/AudioEditorUtils';
import storeManager from '../../../store/StoreManager';
import { VolumeSlider } from '../../menus/VolumeSlider';
import { changeTitle, showTrackMenu } from '../../../actions/AudioEditorActions';
import locales from '../../../locales/LocalesManager';
import hoverManager from '../../utils/HoverManager';
import audioToolUtils from '../../audioTool/utils/AudioToolUtils';
import saveManager from '../../utils/SaveManager';
import textSizeUtils from '../../utils/TextSizeUtils';
import platformDetection from "../../utils/PlatformDetection";

export const AudioElementVolume = React.createClass({
    getInitialState() {
        return {
            isVolumeOver: false,
            openVolumeSlider: false,
            isSettingsOver: false
        };
    },
    componentDidMount() {
        document.addEventListener('click', this.onCloseVolumeSlider);
        document.addEventListener('touchend', this.onCloseVolumeSlider);
    },
    componentWillUnmount() {
        document.removeEventListener('click', this.onCloseVolumeSlider);
        document.removeEventListener('touchend', this.onCloseVolumeSlider);
    },
    onMenuButtonMouseIn() {
        if (audioToolUtils.isLeftSideCollapsed())
            hoverManager.show(this.refs.trackSettings, 'trackSettings', 'right');
        else
            hoverManager.show(this.refs.trackSettings, 'trackSettings');

        this.setState({
            isSettingsOver: true
        });
    },
    onMenuButtonMouseOut() {
        hoverManager.hide();

        this.setState({
            isSettingsOver: false
        });
    },
    onShowMenu(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const state = storeManager.getState();

        if (state.audioEditor.trackMenu == this.props.index)
            this.props.dispatch(showTrackMenu(-1));
        else
            this.props.dispatch(showTrackMenu(this.props.index));
    },
    onVolumeMouseIn () {
        if (audioToolUtils.isLeftSideCollapsed())
            hoverManager.show(this.refs.volumeButton, 'trackVolume', 'right');
        else
            hoverManager.show(this.refs.volumeButton, 'trackVolume');

        this.setState({
            isVolumeOver: true
        });
    },
    onVolumeMouseOut () {
        hoverManager.hide();

        this.setState({
            isVolumeOver: false
        });
    },
    closeVolumeSliderHandler() {
        this.setState({
            openVolumeSlider: false
        });
    },
    onCloseVolumeSlider (e) {
        if (textSizeUtils.isTextEditMode())
            return;

        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (!platformDetection.isIOS()) {
            if (!document.getElementById('htmlColorPicker'))
                e.preventDefault();
        }

        const target = e.target;

        var volume = 'audioElementVolume_' + this.props.index;

        if (target == undefined || (target && target.id == volume) || (target.parentElement && target.parentElement.id == volume))
            return;

        if (target.id == 'volumeIcon') {
            this.setState({
                openVolumeSlider: false
            });

            return;
        }

        if (target.id.indexOf('volumeSlider') != -1 || (target.parentElement && target.parentElement.id.indexOf('volumeSlider') != -1) || (target.parentElement && target.parentElement.parentElement && target.parentElement.parentElement.id.indexOf('volumeSlider') != -1))
            return;

        this.setState({
            openVolumeSlider: false
        });
    },
    onOpenVolumeSlider (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        this.setState({
            openVolumeSlider: true
        });
    },
    getSoundIcon() {
        const state = storeManager.getState();
        var soundVolume;
        var timeline = state.audioEditor.timelines[this.props.index];

        if (timeline) {
            if (timeline.isMute)
                soundVolume = 0;
            else
                soundVolume = timeline.volume;
        }

        if (soundVolume == undefined)
            soundVolume = 0.5;

        if (audioEditorUtils.isVolumeMute(this.props.index))
            return 'fa fa-volume-off';

        var volumeIcon = 'fa fa-volume-down';

        if (soundVolume == 0)
            volumeIcon = 'fa fa-volume-off';
        else if (soundVolume <= 0.5)
            volumeIcon = 'fa fa-volume-down';
        else if (soundVolume > 0.5)
            volumeIcon = 'fa fa-volume-up';

        return volumeIcon;
    },
    onChangeText(e) {
        const newValue = e.target.value;

        if (newValue == undefined)
            return;

        this.props.dispatch(changeTitle(this.props.index, newValue));
    },
    onBlur(e) {
        saveManager.isContentChanged(true);
        audioEditorUtils.addActionToHistory();

        if (e.target)
            e.target.setAttribute('disabled', '');

        this.forceUpdate();
    },
    getText() {
        var title = locales.getCaption('track_1', 'other');

        if (title == undefined || title == '' || title.indexOf('other.') != -1)
            title = 'Track ' + (this.props.index + 1);
        else {
            title = title.replace('1', '');
            title = title + (this.props.index + 1);
        }

        if (this.props.timeline && this.props.timeline.title != undefined)
            title = this.props.timeline.title;

        return title;
    },
    render() {
        var backgroundColor = '#999A9C';
        var isTimelineSelected = this.props.timeline.isSelected;
        var isMenuVisible = false;

        if (this.props.menuIndex != -1) { // is menu opened
            if (this.props.menuIndex == this.props.index)
                isMenuVisible = true;
        }


        if (isTimelineSelected || isMenuVisible)
            backgroundColor = properties.SLIDE_VIEWER_BACKGROUND;

        var menuStyle = {
            position: 'absolute',
            top: this.props.index * audioToolUtils.timelineHeight(),
            left: 0,
            width: audioToolUtils.buttonsHolderWidth(),
            height: audioToolUtils.timelineHeight(),
            background: backgroundColor
        };

        var gap = 12;
        var text = this.getText();
        var titleHeight = 20;
        var titleStyle = {
            position: 'absolute',
            color: 'black',
            top: menuStyle.height / 2 - titleHeight / 2,
            left: 5,
            paddingLeft: 3,
            paddingRight: 3,
            fontSize: 12,
            width: 140,
            height: titleHeight,
            fontWeight: 'bold',
            resize: 'none',
            overflow: 'hidden',
            border: 'none',
            outline: 'none',
            background: 'transparent'
        };

        var isActive = false;

        if (isMenuVisible || document.activeElement ==  this.refs.titleInput) {
            titleStyle.background = 'white';
            isActive = true;
        }

        const verticalLineStyle = {
            position: 'absolute',
            width: properties.LINE_SIZE,
            left: menuStyle.width - properties.LINE_SIZE,
            top: 0,
            height: menuStyle.height,
            background: properties.AUDIO_BORDER
        };

        const horizontalLineStyle = {
            position: 'absolute',
            width: menuStyle.width,
            left: 0,
            top: 0,
            height: properties.LINE_SIZE,
            background: properties.AUDIO_BORDER
        };

        var bottomLine;

        if ((this.props.index + 1) == audioEditorUtils.getTimelinesLength()) {
            const bottomLineStyle = {
                position: 'absolute',
                width: menuStyle.width,
                left: 0,
                top: menuStyle.height,
                height: properties.LINE_SIZE,
                background: properties.AUDIO_BORDER
            };

            bottomLine = <div style={bottomLineStyle} />;
        }

        var iconColor;

        if (this.state.isVolumeOver == true)
            iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
        else
            iconColor = 'black';

        var volumeIconStyle = {
            position: 'absolute',
            top: 7,
            left: 10,
            color: iconColor
        };

        var volumeAreaSize = 30;
        var volumeAreaStyle = {
            position: 'absolute',
            width: volumeAreaSize,
            height: volumeAreaSize,
            left: menuStyle.width - gap - volumeAreaSize,
            top: menuStyle.height / 2 - volumeAreaSize / 2,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            background: 'none',
            borderStyle: 'none'
        };

        // settings button
        if (this.state.isSettingsOver == true)
            iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
        else
            iconColor = 'black';

        const menuButtonStyle = {
            position: 'absolute',
            top: menuStyle.height / 2 - volumeAreaSize / 2,
            left: menuStyle.width - gap - 2 * volumeAreaSize,
            width: volumeAreaSize,
            height: volumeAreaSize,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            background: 'none',
            borderStyle: 'none'
        };

        const menuButtonIconStyle = {
            position: 'absolute',
            top: 7,
            left: 9,
            color: iconColor
        };

        const colorStyle = {
            position: 'absolute',
            top: 0,
            left: menuStyle.width - 10,
            width: 10,
            height: menuStyle.height,
            backgroundColor: audioEditorUtils.getStartColor(this.props.index)
        };

        var isCollapsed = false;

        if (audioToolUtils.isLeftSideCollapsed()) {
            titleStyle.display = 'none';
            isCollapsed = true;
        }

        var soloStyle = {
            position: 'absolute',
            right: 22,
            fontSize: 15,
            fontWeight: 'bold',
            top: 7,
            display: 'none'
        };

        var muteStyle = {
            position: 'absolute',
            right: 22,
            fontSize: 15,
            fontWeight: 'bold',
            bottom: 7,
            display: 'none'
        };

        if (this.state.isVolumeOver == true)
            iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
        else
            iconColor = 'black';

        var muteVolume = {
            position: 'absolute',
            right: 16,
            fontSize: 13,
            fontWeight: 'bold',
            bottom: 28,
            display: 'none',
            color: iconColor
        };

        if (!audioToolUtils.isAudioTool()) {
            soloStyle.right = 24;
            soloStyle.fontSize = 11;
            soloStyle.top = 5;

            muteStyle.right = 24;
            muteStyle.fontSize = 11;
            muteStyle.bottom = 5;

            muteVolume.bottom = 18;
        }

        if (this.props.timeline.isSolo)
            soloStyle.display = 'block';

        if (audioEditorUtils.getSoloIndex() < 0 && this.props.timeline.isMute)
            muteStyle.display = 'block';

        if (audioEditorUtils.isVolumeMute(this.props.index))
            muteVolume.display = 'block';

        var labelValue = locales.getCaption('titleForTrack', 'other') + ' ' + (this.props.index + 1);
        var labelStyle = {
            position: 'absolute',
            left: 5,
            top: 7,
            fontSize: 12,
            width: 140,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default',
            color: 'black',
            background: 'transparent',
            display: 'none'
        };

        if (isActive)
            labelStyle.display = 'inline-block';

        if (!audioToolUtils.isAudioEditorTool() && isActive) { // is Cartoonist
            titleStyle.top = 6;
            titleStyle.paddingTop = 17;

            labelStyle.left = 7;
            labelStyle.top = 9;
            labelStyle.zIndex = 2;
            labelStyle.color = '#2479be';
        }
        
        return (
            <div style={menuStyle}>
                <div style={colorStyle} />
                <label htmlFor={'track_' + this.props.index} style={labelStyle}>{labelValue}</label>
                <input ref='titleInput' id={'track_' + this.props.index} aria-label={labelValue} disabled={true} style={titleStyle} onChange={this.onChangeText} onBlur={this.onBlur} type='text' className={'titleInput trackTitle_' + this.props.index} value={text} spellCheck='false' autoCorrect='off' autoCapitalize='off' autoComplete='off'/>

                <div style={soloStyle}>S</div>
                <div style={muteStyle}>M</div>
                <div style={muteVolume}>x</div>

                <button className="trackSettings" aria-label={text + ' ' + locales.getCaption('trackSettings', 'hover')} ref='trackSettings' style={menuButtonStyle} onTouchEnd={this.onShowMenu} onClick={this.onShowMenu} onMouseOver={this.onMenuButtonMouseIn} onMouseOut={this.onMenuButtonMouseOut}>
                    <i style={menuButtonIconStyle} className="fa fa-bars slideMenuButton trackSettings"></i>
                </button>
                <button ref='volumeButton' aria-label={text + ' ' + locales.getCaption('trackVolume', 'hover')} id={'audioElementVolume_' + this.props.index} style={volumeAreaStyle} onMouseOver={this.onVolumeMouseIn} onMouseOut={this.onVolumeMouseOut} onClick={this.onOpenVolumeSlider} onTouchEnd={this.onOpenVolumeSlider}>
                    <i style={volumeIconStyle} className={this.getSoundIcon()}></i>
                </button>

                <div style={verticalLineStyle} />
                <div style={horizontalLineStyle} />
                {bottomLine}

                <VolumeSlider dispatch={this.props.dispatch} isCollapsed={isCollapsed} visible={this.state.openVolumeSlider} type={'audioEditor'} index={this.props.index} closeVolumeSliderHandler={this.closeVolumeSliderHandler}/>
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/audioEditor/menus/AudioElementVolume.js
 **/